import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import WhatIsACustomerData from './components/WhatIsCustomerData/WhatIsACustomerData'
import DataGovernanceAndControls from './components/DataGovernanceAndControls'

import Sources from './components/Sources'
import { Destinations } from './components/Destinations/Destinations'
import FeatureBoxGroup from './components/FeatureBoxGroup'

import CustomizeYourPipeline from './components/CustomizeYourPipeline'
import StreamlineYourRegulatoryCompliance from './components/StreamlineYourRegulatoryCompliance'
import LookUnderTheHood from './components/LookUnderTheHood'
import AdditionalResources from './components/AdditionalResources'
import FaqSection from './components/FaqSection'

import ogImagePng from './assets/OgConnections.png'

const ConnectionsView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Connections: First-Party Data Collection Platform | Twilio Segment"
        pageDescription="Connections from Twilio Segment allows you to collect, unify, & connect first-party customer data to all of your other data sources in a single platform."
        pageOG={ogImagePng}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <Main>
          <Navigation />
          <Hero />
          <Sources />
          <Destinations />
          <FeatureBoxGroup />
          <WhatIsACustomerData />
          <DataGovernanceAndControls />
          <CustomizeYourPipeline />
          <StreamlineYourRegulatoryCompliance />
          <LookUnderTheHood />
          <AdditionalResources />
          <FaqSection />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default ConnectionsView
